import { storeFile } from '@/api/passenger'
import { updateCheck, getDocument } from '@/api/passenger'
import { getDocumentPassenger, deletePassengerDocument } from '@/api/passenger'

const uploadFile = (context, data) => {
  return storeFile(data).then((response) => {
    return response
  })
}

const updateChecked = (context, data) => {
  return updateCheck(data).then((response) => {
    return response
  })
}

const getDocuments = (context, data) => {
  return getDocumentPassenger(data).then((response) => {
    return response
  })
}

const deletePassengerDocuments = (context, data) => {
  return deletePassengerDocument(data).then((response) => {
    return response
  })
}

export default {
  uploadFile,
  updateChecked,
  getDocuments,
  deletePassengerDocuments
}
